import toastsModel from "./toastsModel";
import authModel from "./authModel";
import { persist } from "easy-peasy";

const storeModel = {
  auth: persist(authModel, { storage: "localStorage" }),
  toasts: toastsModel,
};
export default storeModel;
